var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactBrIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 806,
    height: 732,
    viewBox: "0 0 806 732",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.146 58.2564L728.531 439.286C736.004 445.553 742.727 452.382 748.691 459.659L750.049 461.167V461.34C794.411 517.071 794.986 598.114 747.42 654.8C693.105 719.531 596.586 727.99 531.838 673.695L433.447 591.189H399.208L517.697 690.549C591.754 752.65 702.152 742.974 764.278 668.936C826.403 594.898 816.73 484.535 742.672 422.433L288.287 41.4035C214.23 -20.6985 103.832 -11.0223 41.7063 63.0158C14.267 95.7167 0.833968 135.504 0.768551 175.089H22.7725C22.8402 140.496 34.5847 105.729 58.5638 77.1518C112.879 12.4214 209.399 3.96162 274.146 58.2564Z",
    fill: "url(#paint0_linear_1034_4423)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1034_4423",
    x1: 583.807,
    y1: -65.2754,
    x2: 562.176,
    y2: 735.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333417,
    stopColor: "#D0FBEF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#778DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBrIc);
export default __webpack_public_path__ + "static/media/contactBr_ic.f72add98.svg";
export { ForwardRef as ReactComponent };